import { __assign, __extends } from "tslib";
import { SdkMessageTypes } from '../constants';
import { BaseMessageHandler } from './base-message-handler';
import { formulateSdkResponse, onSdkError } from './messageHandlingUtils';
/**
 * Responsible for interactive module related message requests.
 */
var InteractiveMessageHandler = /** @class */ (function (_super) {
    __extends(InteractiveMessageHandler, _super);
    function InteractiveMessageHandler(appSdkHost, interactiveService, telemetryService) {
        var _this = _super.call(this, appSdkHost, telemetryService) || this;
        _this.appSdkHost = appSdkHost;
        _this.interactiveService = interactiveService;
        _this.telemetryService = telemetryService;
        return _this;
    }
    InteractiveMessageHandler.prototype.initHandlers = function () {
        var _this = this;
        this.registerHandler(SdkMessageTypes.interactive.getFluidTenantInfo, function () { return formulateSdkResponse(_this.getParamsWithOrigin({}), _this.interactiveService.getFluidTenantInfo); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.interactive.getFluidTenantInfo, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.interactive.getFluidToken, function (_, containerId) {
            return formulateSdkResponse(_this.getParamsWithOrigin({ containerId: containerId }), _this.interactiveService.getFluidToken);
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.interactive.getFluidToken, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.interactive.getFluidContainerId, function () { return formulateSdkResponse(_this.getParamsWithOrigin({}), _this.interactiveService.getFluidContainerId); }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.interactive.getFluidContainerId, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.interactive.setFluidContainerId, function (_, containerId) {
            return formulateSdkResponse(_this.getParamsWithOrigin({ containerId: containerId }), _this.interactiveService.setFluidContainerId);
        }, {
            errorCallback: function (error, scenario) {
                return onSdkError(SdkMessageTypes.interactive.setFluidContainerId, error, scenario);
            },
        });
        this.registerHandler(SdkMessageTypes.interactive.getNtpTime, function () { return formulateSdkResponse(_this.getParamsWithOrigin({}), _this.interactiveService.getNtpTime); }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.interactive.getNtpTime, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.interactive.registerClientId, function (_, clientId) {
            return formulateSdkResponse(_this.getParamsWithOrigin({ clientId: clientId }), _this.interactiveService.registerClientId);
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.interactive.registerClientId, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.interactive.getClientRoles, function (_, clientId) {
            return formulateSdkResponse(_this.getParamsWithOrigin({ clientId: clientId }), _this.interactiveService.getClientRoles);
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.interactive.getClientRoles, error, scenario); },
        });
        this.registerHandler(SdkMessageTypes.interactive.getClientInfo, function (_, clientId) {
            return formulateSdkResponse(_this.getParamsWithOrigin({ clientId: clientId }), _this.interactiveService.getClientInfo);
        }, {
            errorCallback: function (error, scenario) { return onSdkError(SdkMessageTypes.interactive.getClientInfo, error, scenario); },
        });
    };
    InteractiveMessageHandler.prototype.getParamsWithOrigin = function (params) {
        var origin = this.appSdkHost.getOrigin();
        if (!origin) {
            throw 'Origin not set of AppSdkHost';
        }
        return __assign(__assign({}, params), { origin: origin });
    };
    InteractiveMessageHandler.prototype.validateDependencies = function () {
        if (!this.interactiveService) {
            throw 'No interactiveService provided';
        }
    };
    return InteractiveMessageHandler;
}(BaseMessageHandler));
export { InteractiveMessageHandler };
//# sourceMappingURL=interactive-message-handler.js.map